import './Navbar.css';

import React, { useState, useContext, useEffect, useRef } from 'react';
import AuthContext from '../../context/AuthContext';
import LoginPop from '../LoginPop/LoginPop';
import { Link } from 'react-router-dom';


export default function Navbar() {

    const { user, logoutUser } = useContext(AuthContext);
    const [showLogin, setShowLogin] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const userMenuRef = useRef(null);

    useEffect(() => {
        function onClick(e) {
            if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
                setUserMenuOpen(false);
            }
        }
        document.addEventListener('mousedown', onClick);
        return () => document.removeEventListener('mousedown', onClick);
    }, []);

    const closeMobile = () => setMobileOpen(false);

    return (
        <>
        {showLogin && <LoginPop toggleShowLogin={() => setShowLogin(false)} />}

        <nav className='navbar' role='navigation' aria-label='Main'>
            <div className='navbar-inner'>

                <Link to='/' className='navbar-brand' onClick={closeMobile}>راوية</Link>

                <button
                    className='navbar-burger'
                    aria-label='Menu'
                    aria-expanded={mobileOpen}
                    onClick={() => setMobileOpen(o => !o)}
                >
                    <span /><span /><span />
                </button>

                <div className={'navbar-links' + (mobileOpen ? ' is-open' : '')}>
                    <Link
                        to={user ? '/myworks' : '/register'}
                        className='navbar-link navbar-link--accent'
                        onClick={closeMobile}
                    >
                        ابدأ الكتابة
                    </Link>
                    <Link to='/library' className='navbar-link' onClick={closeMobile}>المكتبة</Link>
                    <Link to='/discussions' className='navbar-link' onClick={closeMobile}>النقاشات</Link>
                    {user && (
                        <Link to='/bookmarks' className='navbar-link' onClick={closeMobile}>علاماتي</Link>
                    )}

                    {user ? (
                        <div className='navbar-user' ref={userMenuRef}>
                            <button
                                className='navbar-user-toggle'
                                onClick={() => setUserMenuOpen(o => !o)}
                                aria-haspopup='menu'
                                aria-expanded={userMenuOpen}
                            >
                                {user.username}
                            </button>
                            {userMenuOpen && (
                                <div className='navbar-dropdown' role='menu'>
                                    <Link
                                        to='/profile'
                                        className='navbar-dropdown-item'
                                        onClick={() => { setUserMenuOpen(false); closeMobile(); }}
                                    >
                                        الملف الشخصي
                                    </Link>
                                    <button
                                        className='navbar-dropdown-item navbar-dropdown-item--danger'
                                        onClick={() => { setUserMenuOpen(false); closeMobile(); logoutUser(); }}
                                    >
                                        تسجيل الخروج
                                    </button>
                                </div>
                            )}
                        </div>
                    ) : (
                        <button
                            className='navbar-link navbar-link--button'
                            onClick={() => { closeMobile(); setShowLogin(true); }}
                        >
                            تسجيل الدخول
                        </button>
                    )}
                </div>
            </div>
        </nav>
        </>
    );
}
